import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* Global styles */
  body {
    margin: 0;
    background: #f1f4f9;
    font-family: sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html, body, #root {
    // height: 100%;
  }

  #root {
    height: calc(var(--vh, 1dvh) * 100);
    -webkit-transform: translate3d(0, 0, 0);
  }

  input {
    font-family: sans-serif;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield; /* Firefox */
  }

  button {
    font-family: sans-serif;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  /* Styles for the App */
  .App {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow: hidden;
    font-family: sans-serif;
    color: #ffffff;
  }

  /* Background styling */
  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  /* Main content styling */
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  /* YoloMed SVG logo styling */
  .yolomed-logo {
    width: 200px;
    margin-bottom: 20px;
  }

  /* Get Started Button styling */
  .get-started-button {
    width: 373.96px;
    height: 54px;
    background: #FFFFFF;
    color: #000000;
    font-size: 18px;
    border: none;
    border-radius: 5px 0px 0px 0px;
    opacity: 1;
    cursor: pointer;
  }

  /* Terms and Conditions styling */
  .terms {
    margin-top: 20px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18.66px;
    letter-spacing: 0.01em;
    color: #ffffff;
  }

  .header {
    padding: 20px;
  }

  .navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo-container {
    display: flex;
    align-items: center;
  }

  .yolomed-logo {
    height: 50px; /* Adjust the height as necessary */
  }

  .nav-links {
    list-style: none;
    display: flex;
    gap: 20px; /* Space between the links */
    margin: 0;
    padding: 0;
  }

  .nav-links li a {
    text-decoration: none; /* Remove underline from links */
    color: #333; /* Dark text color */
  }

  .nav-links li a:hover {
    color: #007bff; /* Change color on hover */
  }

  .footer {
    width: 100%;
    padding: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .terms a {
    font-size: 12px;
    font-weight: 400;
    line-height: 18.66px;
    letter-spacing: 0.01em;
    color: #4FE3CA;
    text-decoration: underline;
    cursor: pointer;
  }
    .terms2 {
    font-size: 12px;
    font-weight: 400;
    line-height: 18.66px;
    letter-spacing: 0.01em;
    color: #1C2225;
;
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: 480px) {
    .yolomed-logo {
      width: 120px; /* Smaller logo for small screens */
    }

    .get-started-button {
      width: 70%; /* Fit button better on very small screens */
      font-size: 14px;
      padding: 10px;
    }

    .terms,
    .other-text {
      font-size: 10px;
      text-align: center;
      padding: 0 8px;
    }
  }
`;

export default GlobalStyle;
